
















































































import { Input } from './mixins';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue, Prop, Mixins, Emit, Watch } from 'vue-property-decorator';

// @ts-ignore
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
// @ts-ignore
import { Blockquote, HardBreak, Heading, OrderedList, BulletList, ListItem, TodoItem, TodoList, Bold, Code, Italic, Link, Strike, Underline } from 'tiptap-extensions';

@Component({
  components: {
    ValidationProvider,
    EditorContent,
    EditorMenuBar,
  },
})
export default class FormWysiwyg extends Mixins(Input) {
  @Prop({ default: false }) autoFocus?: boolean;

  @Prop({ default: '' }) readonly value!: string;

  @Prop({ default: 'text' }) readonly type!: string;

  isFocussed: boolean = false;

  $refs!: Vue['$refs'] & {
    input: HTMLElement;
  };

  editor: any = null;

  mounted() {
    // @ts-ignore
    this.$refs.provider.value = this.localValue;
    this.editor = new Editor({
      extensions: [
        new Blockquote(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new BulletList(),
        new OrderedList(),
        new ListItem(),
        new TodoItem(),
        new TodoList(),
        new Bold(),
        new Code(),
        new Italic(),
        new Link(),
        new Strike(),
        new Underline(),
      ],
      content: this.localValue,
      useBuiltInExtensions: true,
      autoFocus: this.autoFocus,
      onUpdate: this.updateContent,
      onFocus: this.focus,
      onBlur: this.blur,
    });
  }

  beforeDestroy() {
    this.editor.destroy();
  }

  @Emit('focus')
  private focus(e: Event) {
    this.isFocussed = true;
    return e;
  }

  @Emit('blur')
  private blur(e: Event) {
    this.isFocussed = false;
    return e;
  }

  private updateContent({ getHTML }: any) {
    const html = getHTML();
    // @ts-ignore
    this.$refs.provider.validate(html).then((valid: boolean) => {
      if (valid) {
        this.handleInput(html);
      }
    });
  }

  @Emit('input')
  private handleInput(html: string) {
    return html;
  }
}
